"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Panel = exports.PanelBackgrounds = exports.PanelTypes = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var PanelTypes;
(function (PanelTypes) {
    PanelTypes["BORDER_LEFT_PRIMARY"] = "border-left-primary";
    PanelTypes["BORDER_LEFT_SECONDARY"] = "border-left-secondary";
    PanelTypes["BORDER_LINES_Y"] = "outlines-y";
    PanelTypes["OUTLINES"] = "outlines";
    PanelTypes["BORDER_TOP_DANGER"] = "border-top-danger";
    PanelTypes["BORDER_TOP_WARNING"] = "border-top-warning";
    PanelTypes["BORDER_TOP_PRIMARY"] = "border-top-primary";
    PanelTypes["BORDER_TOP_SECONDARY"] = "border-top-secondary";
    PanelTypes["BORDER_TOP_SUCCESS"] = "border-top-success";
    PanelTypes["BORDER_BOTTOM"] = "border-bottom";
})(PanelTypes = exports.PanelTypes || (exports.PanelTypes = {}));
var PanelBackgrounds;
(function (PanelBackgrounds) {
    PanelBackgrounds["BG_LIGHT"] = "bg-light";
    PanelBackgrounds["BG_PRIMARY_LIGHT"] = "bg-primary-light-5";
    PanelBackgrounds["BG_WHITE"] = "bg-white";
})(PanelBackgrounds = exports.PanelBackgrounds || (exports.PanelBackgrounds = {}));
var Panel = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("panel")
        .add(props.background || "")
        .pmod(props.type || "")
        .pmod(props.hasBorderRadius ? "smooth-border" : "")
        .pmod(props.hasShadow ? "shadow" : "")
        .pmod(props.hasBorder ? "border-solid" : "");
    var prop = __assign({}, props);
    delete prop.hasShadow;
    delete prop.hasBorderRadius;
    delete prop.background;
    delete prop.hasBorder;
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, prop, { className: "".concat(cls.bem, " ").concat(props.className || "") }, { children: props.children })));
};
exports.Panel = Panel;
